var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.322 9.97298C14.3183 10.0117 14.3101 10.0498 14.2975 10.0866L10.6878 20.6615C10.6187 20.8639 10.4285 21 10.2146 21H8.8592C8.51009 21 8.26845 20.6513 8.39103 20.3244L12.8149 8.52756C12.888 8.33241 13.0746 8.20312 13.283 8.20312H13.9418C14.2369 8.20312 14.4677 8.45728 14.4395 8.75098L14.322 9.97298ZM17.7939 21C17.5801 21 17.39 20.8641 17.3208 20.6619L13.7018 10.0845C13.6897 10.0491 13.6816 10.0125 13.6777 9.97525L13.5487 8.75572C13.5174 8.46041 13.749 8.20312 14.0459 8.20312H14.7089C14.9169 8.20312 15.1033 8.33201 15.1767 8.52672L19.6248 20.3236C19.7481 20.6506 19.5065 21 19.157 21H17.7939ZM16.7607 16.2451C17.0369 16.2451 17.2607 16.469 17.2607 16.7451V17.5732C17.2607 17.8494 17.0369 18.0732 16.7607 18.0732H10.8438C10.5676 18.0732 10.3438 17.8494 10.3438 17.5732V16.7451C10.3438 16.469 10.5676 16.2451 10.8438 16.2451H16.7607Z",
    fill: "#050022"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ecae2eac13d96ee6dc7a760623ebcf04.svg";
export { ForwardRef as ReactComponent };